import React from 'react'
import { connect } from 'react-redux'
import { Control, Form, Errors, actions } from 'react-redux-form'
// UI
import Textfield from 'react-mdl/lib/Textfield'
import Button from 'UI/Button'
// Settings
import { validators } from 'Constants'
import { SelectField, Option } from 'react-mdl-extra'
import Select from 'react-select';
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import UploadAdminExchangeRate from './UploadAdminExchangeRate';
import Modal from 'reboron/OutlineModal';
import {
  columnFieldModalStyle,
  suggestedValueContentStyle, ExcelUploadColumns,
  backdropStyle, exportOptionsModalStyle, changeModalContentStyle, modalContentStyle, changeModalStyle
} from 'Constants';

// Actions
import {
  userDetailsSuccess,
  userDetailsFailure,
  userDetailsLoading,
  resetError,
  adminExchangeUpsert,
  updateExchangeRateDetails
}
  from 'actions/userActions'

import { dropdownStyles } from 'react-select-css'
import { trackUserSpendSelections } from '../../actions/spendActions'



class ExchangeMaster extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      userIsEditing: false,
      editId: 0,
      options: [],
      sizes: [],
      layout: '',
      size: '',
      exchange: [],
      sequence: [],
      mymessage: '',
      exchangeDate: new Date(),

      // NEW: search query for client-side filtering
      searchQuery: '',
    }

    this.loadData = this.loadData.bind(this)
    // NEW: bind handlers
    this.handleSearchChange = this.handleSearchChange.bind(this)
    this.downloadCSV = this.downloadCSV.bind(this)
  }

  componentWillMount() {
    this.loadData()

  }
  loadData() {
    var param = { USER_ID: localStorage.getItem('loggedinUser'), RECORD_FLAG: 'R' };
    this.props.adminExchangeUpsert(param)
      .then((response) => {
        var exchangeData = [];
        this.props.userDetailsSuccess(response.data.Message)
        for (var i = 0; i < response.data.Result.length; i++) {
          var obj = response.data.Result[i];
          var excData = {
            id: obj.CURRENCY_ID, from_cur: obj.FROM_CURRENCY_CD, from_cur_name: obj.FROM_CURRENCY_NAME,
            to_cur: obj.TO_CURRENCY_CD, to_cur_name: obj.TO_CURRENCY_NAME,
            exchange_rate: obj.EXCHANGE_RATE, exchange_date: obj.EXCHANGE_DATE,user_id : obj.USER_ID,
            currency_identifier:obj.CURRENCY_IDENTIFIER,
            isEditing: false
          }
          exchangeData.push(excData);
        }
        this.setState({ exchange: exchangeData })
      }).catch((error) => {
        if (error.stack.includes('Network Error')) {
          this.props.userDetailsFailure()
        }
      })
  }

  componentDidUpdate(prevProps) {
    if (this.props.user.error && !prevProps.user.error) {
      // Clear any existing success message when an error appears
      if (this.state.mymessage) {
        this.setState({ mymessage: "" });
      }
    }
  }

  handleRowDel(currencyDetails) {
    // const result = window.confirm(this.props.validation.confirmDelete);
    // if (result) {
    var formValues = { CURRENCY_CODE: currencyDetails.name, CURRENCY_CD_ID: currencyDetails.id, RECORD_FLAG: 'D' };
    var msg = this.props.content.rowDel[0];
    this.setState({ mymessage: "" })
    this.props.user.error = "";
    this.props.adminCurrencyUpsert(formValues)
      .then((response) => {
        this.props.userDetailsSuccess(response.data.Message)

        if (response.status === 200) {
          var httpstatus = response.status
          var getMsgfromStatus = msg[httpstatus]
          this.loadData()
          this.setState({ mymessage: getMsgfromStatus })
          this.props.user.error = "";
        }
      }).catch((error) => {
        if (error.stack.includes('Network Error')) {
          this.setState({ mymessage: "" })
          this.props.userDetailsFailure(this.props.validation.networkError)
        }
        else {
          var httpstatus = error.response.status
          var getMsgfromStatus = msg[httpstatus]
          if (getMsgfromStatus !== undefined) {
            this.setState({ mymessage: "" })
            this.props.userDetailsFailure(getMsgfromStatus)
          }
          else {
            this.setState({ mymessage: "" })
            this.props.userDetailsFailure(error.response.data.Message)
          }
        }
      })
    // }
  };

  handleEditEvent(evt) {
    var item = {
      id: evt.id,
      from_cur: evt.from_cur,
      from_cur_name: evt.from_cur_name,
      to_cur: evt.to_cur,
      to_cur_name: evt.to_cur_name,
      exchange_rate: evt.exchange_rate,
      exchange_date: evt.exchange_date,
      description: evt.description,
      isEditing: evt.isEditing
    };
    var old_exchangeDetails = this.state.exchange.slice();
    var new_exchangeDetails = old_exchangeDetails.map(function (testExchangeDetails) {
      for (var key in testExchangeDetails) {
        if (testExchangeDetails.id == item.id) {
          testExchangeDetails.from_cur = item.from_cur;
          testExchangeDetails.from_cur_name = item.from_cur_name;
          testExchangeDetails.to_cur = item.to_cur;
          testExchangeDetails.to_cur_name = item.to_cur_name;
          testExchangeDetails.exchange_rate = item.exchange_rate;
          testExchangeDetails.exchange_date = item.exchange_date;
          testExchangeDetails.description = item.description;
          testExchangeDetails.isEditing = !item.isEditing;

          if (evt.UpdatedBy !== undefined) {
            testExchangeDetails.UpdatedBy = evt.UpdatedBy;
            testExchangeDetails.UpdatedOn = evt.UpdatedOn;
          }
          break;
        }
      }
      return testExchangeDetails;
    });

    this.setState({ currency: new_exchangeDetails });
    this.formDispatch(actions.reset('exchangeManager'))
  }

  handleCancelEvent(originalDetails) {
    var item = {
      id: originalDetails.id,
      from_cur: originalDetails.from_cur,
      from_cur_name: originalDetails.from_cur_name,
      to_cur: originalDetails.to_cur,
      to_cur_name: originalDetails.to_cur_name,
      exchange_rate: originalDetails.exchange_rate,
      exchange_date: originalDetails.exchange_date,
      description: originalDetails.description,
      isEditing: originalDetails.isEditing
    };

    var old_exchangeDetails = this.state.exchange.slice();
    var new_exchangeDetails = old_exchangeDetails.map(function (testExchangeDetails) {
      for (var key in testExchangeDetails) {
        if (testExchangeDetails.id === item.id) {
          testExchangeDetails.from_cur = item.from_cur;
          testExchangeDetails.from_cur_name = item.from_cur_name;
          testExchangeDetails.to_cur = item.to_cur;
          testExchangeDetails.to_cur_name = item.to_cur_name;
          testExchangeDetails.exchange_rate = item.exchange_rate;
          testExchangeDetails.exchange_date = item.exchange_date;
          testExchangeDetails.description = item.description;
          testExchangeDetails["isEditing"] = false;
          break;
        }
      }
      return testExchangeDetails;
    });
    this.setState({ exchange: new_exchangeDetails });

  };

  handleUpdateEvent(updateDetails) {
    if (updateDetails) {
      var item = {
        CURRENCY_ID: updateDetails.id,
        CURRENCY_IDENTIFIER: '$' + updateDetails.to_cur.toUpperCase() + updateDetails.from_cur.toUpperCase(),
        FROM_CURRENCY_CD: updateDetails.from_cur.toUpperCase(),
        FROM_CURRENCY_NAME: updateDetails.from_cur_name,
        TO_CURRENCY_CD: updateDetails.to_cur.toUpperCase(),
        TO_CURRENCY_NAME: updateDetails.to_cur_name,
        EXCHANGE_RATE: updateDetails.exchange_rate,
        EXCHANGE_DATE: this.state.exchange.find(exc => exc.id == updateDetails.id).exchange_date,
        USER_ID: localStorage.getItem('loggedinUser'),
        RECORD_FLAG: 'U'
      }
      
      var result = this.state.exchange.find(exc => exc.from_cur.toLowerCase() == item.FROM_CURRENCY_CD.toLowerCase() && exc.to_cur.toLowerCase() == item.TO_CURRENCY_CD.toLowerCase()) === undefined
      if (!result) {
        this.props.userDetailsFailure('This exchange rate already exists!')
      }
      else {
        this.props.updateExchangeRateDetails([item])
          .then((results) => {
            var msg = this.props.content.rowUpdate[0];
            if (results.status === 200) {
              var httpstatus = results.status
              var getMsgfromStatus = msg[httpstatus]

              this.props.userDetailsSuccess(getMsgfromStatus)
              this.setState({ mymessage: getMsgfromStatus })
              this.props.user.error = "";
              // item.UpdatedBy = results.data.Result.UpdatedBy;
              // item.UpdatedOn = results.data.Result.UpdatedOn;
              this.handleEditEvent(item)
            }
            this.loadData()
            this.setState({ userIsEditing: false })

          }).catch((error) => {
            if (error.stack.includes('Network Error')) {
              this.props.userDetailsFailure('API service is down. Please contact administrator.')
            }
            else {
              this.props.userDetailsFailure(error.response.data.Message)
            }
          })
      }
    }
  }

  addExchangeRates(formValue) {
    this.props.resetError();
    var exchangeRateDetails = {
      CURRENCY_ID: null,
      CURRENCY_IDENTIFIER: '$' + formValue.To_Cur.toUpperCase() + formValue.From_Cur.toUpperCase(),
      FROM_CURRENCY_CD: formValue.From_Cur.toUpperCase(),
      FROM_CURRENCY_NAME: formValue.From_Cur_Name,
      TO_CURRENCY_CD: formValue.To_Cur.toUpperCase(),
      TO_CURRENCY_NAME: formValue.To_Cur_Name,
      EXCHANGE_RATE: formValue.Exchange_Rate,
      EXCHANGE_DATE: this.convertDate(this.state.exchangeDate),//this.state.exchangeDate,
      USER_ID: localStorage.getItem('loggedinUser'),
      RECORD_FLAG: 'I'
    }
    var msg = this.props.content;
    var result = this.state.exchange.find(exc => exc.from_cur.toLowerCase() == exchangeRateDetails.FROM_CURRENCY_CD.toLowerCase() && exc.to_cur.toLowerCase() == exchangeRateDetails.TO_CURRENCY_CD.toLowerCase()) === undefined
    if (!result) {
      this.props.userDetailsFailure('This exchange rate already exists!')
    }
    else {
      this.setState({ mymessage: "" })
      this.props.user.error = "";
      this.props.updateExchangeRateDetails([exchangeRateDetails]).then((results) => {
        if (results.status === 200) {
          var httpstatus = results.status
          var getMsgfromStatus = msg[httpstatus]
          // Reset form
          this.formDispatch(actions.reset('exchangeManager'))
          this.loadData()
          this.setState({ mymessage: getMsgfromStatus })
          this.props.user.error = "";
        }
      }).catch((error) => {
        if (error.stack.includes('Network Error')) {
          this.setState({ mymessage: "" })
          this.props.userDetailsFailure('API service is down. Please contact administrator.')
        }
        else {
          this.setState({ mymessage: "" })
          this.props.userDetailsFailure(error.response.data.Message)
        }
      })
    }

  }


  isDuplicate(vals) {
    var result = this.state.exchange.find(exc => exc.from_cur === vals.trim()) === undefined
    if (result) {
      return result;
    }
    else {
      return result;
    }
  }

  setExchangeDate(date) {
    this.setState({ exchangeDate: date })
    //document.forms[0][5].value = date;
  }

  handleKeyPressExchangeRate = (event) => {
    // Allow only numbers and a decimal point
    const regex = /^[0-9.]$/;
    if (!regex.test(event.key) || (event.key === '.' && event.target.value.includes('.'))) {
      event.preventDefault();
    }
  };


  // handleKeyPressCurrency = (event) => {
  //   const inputValue = event.target.value;

  //   // Allow only alphabetic characters (uppercase or lowercase)
  //   const isLetter = /^[A-Za-z]$/.test(event.key);

  //   // Ensure the length of input is no more than 3 characters (currency codes are 3 characters)
  //   if (!isLetter || inputValue.length >= 3) {
  //     event.preventDefault();
  //   }
  // }

  handleKeyPressCurrency = (event) => {
    const input = event.target;
    const inputValue = input.value;
    const key = event.key;
  
    // Allow only alphabetic characters
    const isLetter = /^[A-Za-z]$/.test(key);
    if (!isLetter) {
      event.preventDefault();
      return;
    }
  
    const selectionStart = input.selectionStart;
    const selectionEnd = input.selectionEnd;
    const isAllSelected = selectionStart === 0 && selectionEnd === inputValue.length;
  
    // If all text is selected, replace everything with the new letter
    if (isAllSelected) {
      event.preventDefault();
      input.value = key.toUpperCase();
      input.dispatchEvent(new Event("input", { bubbles: true }));
      return;
    }
  
    // If already 3 letters, replace the 3rd one
    if (inputValue.length === 3) {
      event.preventDefault();
      const newValue = inputValue.substring(0, 2) + key.toUpperCase();
      input.value = newValue;
      input.dispatchEvent(new Event("input", { bubbles: true }));
    }
  };
  

  convertDate(d) {

    const monthNames = ["Jan", "Feb", "Mar", "Apr",
      "May", "Jun", "Jul", "Aug",
      "Sep", "Oct", "Nov", "Dec"];

    const day = d.getDate();

    const monthIndex = d.getMonth();
    const monthName = monthNames[monthIndex];

    const year = d.getFullYear();

    return `${day}-${monthName}-${year}`;
  }

  setExchangeDateRow(date, id) {
    const index = this.state.exchange.findIndex((item) => item.id === id);

    let items = [...this.state.exchange];
    // 2. Make a shallow copy of the item you want to mutate
    let item = { ...items[index] };
    // 3. Replace the property you're intested in
    item.exchange_date = this.convertDate(date);
    // 4. Put it back into our array. N.B. we *are* mutating the array here, 
    //    but that's why we made a copy first
    items[index] = item;
    // 5. Set the state to our new copy
    this.setState({ exchange: items });

  }

  componentWillUnmount() {
    this.formDispatch(actions.reset('exchangeManager'))
    this.props.resetError();
  }

  closeUploadExchangeRatePopup() {
    //this.setState({ columns: cloneDeep(this(originalColumns) });
    this.hideModal('UploadAdminExchangeRate');
  }

  showModal(action) {
    this.refs[action].show()
  }

  hideModal(action) {
    this.refs[action].hide()
  }

  // NEW: search change handler
  handleSearchChange(e) {
    this.setState({ searchQuery: e.target.value })
  }

  // NEW: download CSV of given rows
  downloadCSV(rows, filename = 'exchange-data.csv') {
    if (!rows || !rows.length) {
      // nothing to download
      return;
    }

    // define columns - order must match headers
    const headers = [
      'currency_identifier',
      'from_cur',
      'from_cur_name',
      'to_cur',
      'to_cur_name',
      'exchange_rate',
      'exchange_date',
      'user_id'
    ];

    const csvRows = [];
    csvRows.push(headers.join(',')); // header row

    rows.forEach(row => {
      const values = headers.map(h => {
        let val = row[h] === undefined || row[h] === null ? '' : String(row[h]);
        // escape quotes
        if (val.includes('"') || val.includes(',') || val.includes('\n')) {
          val = '"' + val.replace(/"/g, '""') + '"';
        }
        return val;
      });
      csvRows.push(values.join(','));
    });

    const csvString = csvRows.join('\n');
    const blob = new Blob([csvString], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = url;
    link.setAttribute('download', filename);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  }

  render() {
    // apply client-side filtering based on searchQuery
    const q = (this.state.searchQuery || '').trim().toLowerCase();
    const filteredExchange = q.length === 0 ? this.state.exchange : this.state.exchange.filter(item => {
      // match against several fields
      return (
        (item.currency_identifier && item.currency_identifier.toString().toLowerCase().includes(q)) ||
        (item.from_cur && item.from_cur.toString().toLowerCase().includes(q)) ||
        (item.from_cur_name && item.from_cur_name.toString().toLowerCase().includes(q)) ||
        (item.to_cur && item.to_cur.toString().toLowerCase().includes(q)) ||
        (item.to_cur_name && item.to_cur_name.toString().toLowerCase().includes(q)) ||
        (item.exchange_rate && item.exchange_rate.toString().toLowerCase().includes(q)) ||
        (item.exchange_date && item.exchange_date.toString().toLowerCase().includes(q)) ||
        (item.user_id && item.user_id.toString().toLowerCase().includes(q))
      );
    });

    return (
      <div>
        <div className="medium-12 title">{this.props.content.title}</div>
        <div className="float-right pr15 pt10" >
        {/* <button onClick={() => this.downloadCSV(filteredExchange, 'exchange-visible.csv')} style={{ padding: '8px 12px' }}>
            Download visible
          </button> */}
          {/* <button onClick={() => this.downloadCSV(this.state.exchange, 'exchange-all.csv')} style={{ padding: '8px 12px' }} title='Download'>{<img class="rotateimg180" width="20" src="images/export_active.svg" />}
          </button> */}
          {/* <button onClick={() => this.showModal('UploadAdminExchangeRate')} title={this.props.content.uploadExcel} >{<img className="hand-cursor" width="20" src="images/export_active.svg" />}</button> */}
          <Modal className="column-field-modal"
            ref={'UploadAdminExchangeRate'} backdropStyle={backdropStyle}
            keyboard={() => this.callback()}
            modalStyle={columnFieldModalStyle}
            contentStyle={suggestedValueContentStyle}
          >
            <UploadAdminExchangeRate
              columnData={this.state.finalColumn}
              rowData={this.state.rowData}
              reloadGrid={() => this.loadData()}
              closePopup={() => this.closeUploadExchangeRatePopup()} />
            <button onClick={() => this.closeUploadExchangeRatePopup()} className='close' />
          </Modal>
        </div>
        <div>
          <Form model="exchangeManager" method="post"
            getDispatch={(dispatch) => this.formDispatch = dispatch}
            onSubmit={(formValue) => this.addExchangeRates(formValue)}>

            <div className="grid-x grid-padding-x medium-12" >
              <div className="medium-1 cell" >
                <Control.text
                  model="exchangeManager.From_Cur"
                  component={Textfield}
                  validateOn="blur"
                  onKeyPress={this.handleKeyPressCurrency}
                  label='From Cur Code'//{this.props.content.from_cur}
                  floatingLabel
                  validators={{
                    required: validators.required,
                    currency: validators.currency
                  }}
                />
                <Errors
                  className="errors"
                  model="exchangeManager.From_Cur"
                  show="touched"
                  messages={{
                    required: this.props.validation.required,
                    currency: this.props.validation.validCurrencyCode
                  }}
                />
              </div>

              <div className="medium-2 cell" >
                <Control.text
                  model="exchangeManager.From_Cur_Name"
                  component={Textfield}
                  validateOn="blur"
                  label={this.props.content.from_cur_name}
                  floatingLabel
                  validators={{
                    required: validators.required,
                  }}
                />
                <Errors
                  className="errors"
                  model="exchangeManager.From_Cur_Name"
                  show="touched"
                  messages={{
                    required: this.props.validation.required,
                  }}
                />
              </div>

              <div className="medium-1 cell" >
                <Control.text
                  model="exchangeManager.To_Cur"
                  component={Textfield}
                  validateOn="blur"
                  onKeyPress={this.handleKeyPressCurrency}
                  label='To Cur Code'//{this.props.content.to_cur}
                  floatingLabel
                  validators={{
                    required: validators.required,
                  }}
                />
                <Errors
                  className="errors"
                  model="exchangeManager.To_Cur"
                  show="touched"
                  messages={{
                    required: this.props.validation.required,
                  }}
                />
              </div>

            {/* </div>
            <div className="grid-x grid-padding-x" > */}
              <div className="medium-2 cell" >
                <Control.text
                  model="exchangeManager.To_Cur_Name"
                  component={Textfield}
                  validateOn="blur"
                  label={this.props.content.to_cur_name}
                  floatingLabel
                  validators={{
                    required: validators.required,
                  }}
                />
                <Errors
                  className="errors"
                  model="exchangeManager.To_Cur_Name"
                  show="touched"
                  messages={{
                    required: this.props.validation.required,
                  }}
                />
              </div>
              <div className="medium-1 cell" >
                <Control.text
                  model="exchangeManager.Exchange_Rate"
                  component={Textfield}
                  validateOn="blur"
                  onKeyPress={this.handleKeyPressExchangeRate}
                  label={this.props.content.exchange_rate}
                  floatingLabel
                />
              </div>
              <div className="medium-1 cell" >
                <Control.custom                  
                  model="exchangeManager.Exchange_Date"
                  id="exchangeManager.Exchange_Date"
                  component={DatePicker}
                  controlProps={{                   
                    selected: new Date(this.state.exchangeDate),
                    className: "calendar-text-exchangerate",
                    popperClassName: "calendar-popper",
                    onChange: date => this.setExchangeDate(date)
                  }}
                />
              </div>

              <div className="medium-2 cell" style={{ marginTop: 15 }}>
                <Button
                  type="submit"
                  disabled={this.props.user.loading}
                  content={this.props.content.cta}
                  color                  
                />
              </div>
              <div className="medium-1 cell" style={{ display: 'inline-flex', gap: 8, alignItems: 'center' }}>
                <button type="button" formNoValidate onClick={() => this.downloadCSV(this.state.exchange, 'exchange-all.csv')} style={{ padding: '8px 12px' }} title='Download' aria-label="Download all">
                  <img className="rotateimg180" width="20" src="images/export_active.svg" alt="download" />
                </button>

                <button type="button" formNoValidate onClick={() => this.showModal('UploadAdminExchangeRate')} title={this.props.content.uploadExcel} aria-label="Upload excel" style={{ padding: '8px 12px' }}>
                  <img className="hand-cursor" width="20" src="images/export_active.svg" alt="upload" />
                </button>
              </div>
              <div className="medium-1 cell" >
                {/* NEW: Search box + Download buttons */}
                <div style={{ marginTop: 12, marginBottom: 12, display: 'flex', alignItems: 'center', gap: 8 }}>
                  <input
                    type="text"
                    placeholder="Search"
                    value={this.state.searchQuery}
                    onChange={this.handleSearchChange}
                    style={{ padding: '8px 10px', width: 320, borderRadius: 4, border: '1px solid #ccc' }}
                  />

                </div>
              </div>
            </div>

          </Form>

          {/* <div className="errors">{this.props.user.error}</div>
          <div className="success">{this.state.mymessage}</div> */}
          {this.props.user.error ? (
            <div className="errors">{this.props.user.error}</div>
          ) : this.state.mymessage ? (
            <div className="success">{this.state.mymessage}</div>
          ) : null}
        </div>
       

        <div className="grid-x" className="medium-11 medium-offset-0">
          <UserTable
            onRowDel={this.handleRowDel.bind(this)}
            onRowEdit={this.handleEditEvent.bind(this)}
            onRowCancel={this.handleCancelEvent.bind(this)}
            onRowUpdate={this.handleUpdateEvent.bind(this)}
            onExchangeDateRowUpdate={this.setExchangeDateRow.bind(this)}
            userEditing={this.state.userIsEditing}
            editId={this.state.editId}
            validation={this.props.validation}
            exchange={filteredExchange}  
            isDuplicate={this.isDuplicate.bind(this)}
          />
        </div>

      </div>
    );
  }
}

/* --- UserTable, UserRow, EditableCell, NonEditableRow remain unchanged --- */

class UserTable extends React.Component {
  render() {
    var rowDel = this.props.onRowDel;
    var rowEdit = this.props.onRowEdit;
    var rowCancel = this.props.onRowCancel;
    var rowUpdate = this.props.onRowUpdate;
    var exchangeDateRow = this.props.onExchangeDateRowUpdate;
    var userEditing = this.props.userEditing;
    var isDuplicate = this.props.isDuplicate;
    var editId = this.props.editId;
    var validation = this.props.validation;
    var exchange = this.props.exchange.map(function (exchange) {
      return (<UserRow
        onDelEvent={rowDel.bind(this)}
        onEditEvent={rowEdit.bind(this)}
        onCancelEvent={rowCancel.bind(this)}
        onUpdateEvent={rowUpdate.bind(this)}
        setExchangeDateRow={exchangeDateRow.bind(this)}
        userIsEditing={userEditing}
        isDuplicate={isDuplicate}
        editId={editId}
        validation={validation}
        exchange={exchange}
        key={exchange.id} />)
    });
    return (
      <div className="basic-table">
        <table>
          <thead>
            <tr>
              <th>Currency Identifier</th>
              <th>From</th>
              <th>From Currency Name</th>
              <th>To</th>
              <th>To Currency Name</th>
              <th>Exchange Rate</th>
              <th>Exchange Date</th>
              <th>Added By</th>
              <th></th>
              <th></th>
            </tr>
          </thead>

          <tbody>
            {exchange}
          </tbody>
        </table>
      </div>
    );
  }
}

class UserRow extends React.Component {
  constructor(props) {
    super(props);
  }


  render() {
    return (
      this.props.exchange.isEditing ?
        <EditableCell
          exchange={this.props.exchange}
          cellData={{
            currency_identifier: this.props.exchange.currency_identifier,
            from_cur: this.props.exchange.from_cur,
            from_cur_name: this.props.exchange.from_cur_name,
            to_cur: this.props.exchange.to_cur,
            to_cur_name: this.props.exchange.to_cur_name,
            exchange_rate: this.props.exchange.exchange_rate,
            exchange_date: this.props.exchange.exchange_date,
            id: this.props.exchange.id,
            isEditing: this.props.exchange.isEditing,
            user_id: this.props.exchange.user_id
          }}
          onCancelEvent={this.props.onCancelEvent}
          setExchangeDateRow={this.props.setExchangeDateRow}
          onUpdateEvent={this.props.onUpdateEvent}
          isEditing={this.props.exchange.isEditing}
          validation={this.props.validation}
          isDuplicate={this.props.isDuplicate}
        />
        :
        <NonEditableRow
          exchange={this.props.exchange}
          cellData={{
            currency_identifier: this.props.exchange.currency_identifier,
            from_cur: this.props.exchange.from_cur,
            from_cur_name: this.props.exchange.from_cur_name,
            to_cur: this.props.exchange.to_cur,
            to_cur_name: this.props.exchange.to_cur_name,
            exchange_rate: this.props.exchange.exchange_rate,
            exchange_date: this.props.exchange.exchange_date,
            id: this.props.exchange.id,
            isEditing: this.props.exchange.isEditing,
            user_id: this.props.exchange.user_id
          }}
          onDelEvent={this.props.onDelEvent}
          onEditEvent={this.props.onEditEvent}
          isEditing={this.props.exchange.isEditing}
        />
    );
  }
}

class EditableCell extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      exchangeDetails: Object.assign({}, this.props.cellData),
      originalExchangeDetails: Object.assign({}, this.props.cellData),
      flag1: false,
      flag2: false
    };
    this.onChangeEvent = this.onChangeEvent.bind(this);
  }


  onCancelEvent() {
    this.setState({ isEditing: false });
    this.props.onCancelEvent(this.state.originalExchangeDetails);
  }

  onUpdateEvent() {
    this.props.onUpdateEvent(this.state.exchangeDetails);
  }

  onChangeEvent(event) {
    var changeItem = this.state.exchangeDetails;
    changeItem[event.target.name] = event.target.value;
    this.setState({ exchangeDetails: changeItem });
  }

  handleKeyPressExchangeRate = (event) => {
    const regex = /^[0-9.]$/;
    if (!regex.test(event.key) || (event.key === '.' && event.target.value.includes('.'))) {
      event.preventDefault();
    }
  };

  setExchangeDateRow(date, id) {
    this.props.setExchangeDateRow(date, id);
  }

  isDuplicate(vals) {
    if (vals === undefined) {
      return this.props.isDuplicate("");
    }
    else {
      return this.props.isDuplicate(vals);
    }

  }

  render() {
    return (
      <tr>
        <td>
          <span>{this.props.cellData.currency_identifier}</span>
        </td>
        <td>
          <Form model="editExcFromCur"
            getDispatch={(dispatch) => this.formDispatch = dispatch}
          >
            <Control.text
              model="editExcFromCur.FromCur"
              component={Textfield}
              defaultValue={this.props.cellData.from_cur}
              name={"from_cur"}
              id={this.props.cellData.id}
              value={this.state.exchangeDetails.from_cur}
              onChange={this.onChangeEvent}
              onKeyPress={this.handleKeyPressCurrency}
              validateOn="change"
              validators={{
                required: validators.required,
                currency: validators.currency
              }}
              controlProps={{
                style: { width: '100px' },
              }}
              type='name' />
            <Errors
              className="errors"
              model="editExcFromCur.FromCur"
              show={(field) => field.focus}
              messages={{
                required: this.props.validation.required,
                currency: this.props.validation.validCurrencyCode
              }} />
          </Form>
        </td>
        <td>
          <Form model="editExcFromCurName"
            getDispatch={(dispatch) => this.formDispatch = dispatch}
          >
            <Control.text
              model="editExcFromCurName.FromCurName"
              component={Textfield}
              defaultValue={this.props.cellData.from_cur_name}
              name={"from_cur_name"}
              id={this.props.cellData.id}
              onChange={this.onChangeEvent.bind(this)}
              isEditing={this.props.cellData.isEditing}
              validateOn="change"
              validators={{
                required: validators.required
              }}
              controlProps={{
                style: { width: '130px' },
              }}
              type='name' />
            <Errors
              className="errors"
              model="editExcFromCurName.FromCurName"
              show={(field) => field.focus}
              messages={{
                required: this.props.validation.required
              }} />
          </Form>
        </td>
        <td>
          <Form model="editExcToCur"
            getDispatch={(dispatch) => this.formDispatch = dispatch}
          >
            <Control.text
              model="editExcToCur.ToCur"
              component={Textfield}
              defaultValue={this.props.cellData.to_cur}
              onKeyPress={this.handleKeyPressCurrency}
              name={"to_cur"}
              id={this.props.cellData.id}
              onChange={this.onChangeEvent.bind(this)}
              isEditing={this.props.cellData.isEditing}
              validateOn="change"
              validators={{
                required: validators.required,
                currency: validators.currency
              }}
              controlProps={{
                style: { width: '100px' },
              }}
              type='name' />
            <Errors
              className="errors"
              model="editExcToCur.ToCur"
              show={(field) => field.focus}
              messages={{
                required: this.props.validation.required,
                currency: this.props.validation.validCurrencyCode
              }} />
          </Form>
        </td>
        <td>
          <Form model="editExcToCurName"
            getDispatch={(dispatch) => this.formDispatch = dispatch}
          >
            <Control.text
              model="editExcToCurName.ToCurName"
              component={Textfield}
              defaultValue={this.props.cellData.to_cur_name}
              name={"to_cur_name"}
              id={this.props.cellData.id}
              onChange={this.onChangeEvent.bind(this)}
              isEditing={this.props.cellData.isEditing}
              validateOn="change"
              validators={{
                required: validators.required
              }}
              controlProps={{
                style: { width: '130px' },
              }}
              type='name' />
            <Errors
              className="errors"
              model="editExcToCurName.ToCurName"
              show={(field) => field.focus}
              messages={{
                required: this.props.validation.required
              }} />
          </Form>
        </td>
        <td>
          <Form model="editExchangeRate"
            getDispatch={(dispatch) => this.formDispatch = dispatch}
          >
            <Control.text
              model="editExchangeRate.ExchangeRate"
              component={Textfield}
              defaultValue={this.props.cellData.exchange_rate}
              name={"exchange_rate"}
              onKeyPress={this.handleKeyPressExchangeRate}
              id={this.props.cellData.id}
              onChange={this.onChangeEvent.bind(this)}
              isEditing={this.props.cellData.isEditing}
              controlProps={{
                style: { width: '70px' },
              }}
              type='name' />
          </Form>
        </td>
        <td>
          <Form model="editExchangeDate"
            getDispatch={(dispatch) => this.formDispatch = dispatch}
          >
            <Control.custom
              model="editExchangeDate.ExchangeDate"
              id="editExchangeDate.ExchangeDate"
              component={DatePicker}
              name={"exchange_date"}
              controlProps={{
                style: { width: '150px' },
                selected: new Date(this.props.cellData.exchange_date),
                className: "calendar-text",
                popperClassName: "calendar-popper",
                onChange: date => this.setExchangeDateRow(date, this.props.cellData.id)
              }}
            />
          </Form>
        </td>
        <td>
          <span>{this.props.cellData.user_id}</span>
        </td>
        <td>
          <button onClick={this.onUpdateEvent.bind(this)}>Update</button>
        </td>
        <td >
          <button onClick={this.onCancelEvent.bind(this)}>Cancel</button>
        </td>
      </tr>
    );
  }
}

class NonEditableRow extends React.Component {

  onDelEvent() {
    this.props.onDelEvent(this.props.cellData);
  }

  onEditEvent() {
    this.props.onEditEvent(this.props.cellData);
  }

  render() {
    return (
      <tr>
        <td>
        <span id={this.props.cellData.id}>{this.props.cellData.currency_identifier}</span>
        </td>
        <td>
          <span>{this.props.cellData.from_cur}</span>
        </td>        
        <td>
          <span>{this.props.cellData.from_cur_name}</span>
        </td>
        <td>
          <span>{this.props.cellData.to_cur}</span>
        </td>
        <td>
          <span>{this.props.cellData.to_cur_name}</span>
        </td>
        <td>
          <span>{this.props.cellData.exchange_rate}</span>
        </td>
        <td>
          <span>{this.props.cellData.exchange_date}</span>
        </td>
        <td>
          <span>{this.props.cellData.user_id}</span>
        </td>
        <td>
          <button onClick={this.onEditEvent.bind(this)}>Edit</button>
        </td>
        <td>
          {/* <button onClick={this.onDelEvent.bind(this)}>Delete</button> */}
        </td>
      </tr>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    language: state.language,
    ui: state.content.ui,
    user: state.default,
    content: state.content.exchange,
    validation: state.content.validation
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    userDetailsLoading: (bool) => dispatch(userDetailsLoading(bool)),
    userDetailsSuccess: (bool) => dispatch(userDetailsSuccess(bool)),
    userDetailsFailure: (error) => dispatch(userDetailsFailure(error)),
    resetError: () => dispatch(resetError()),
    updateExchangeRateDetails: (records) => dispatch(updateExchangeRateDetails(records)),
    adminExchangeUpsert: (exchangeMasterData) => dispatch(adminExchangeUpsert(exchangeMasterData)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ExchangeMaster)
